export default "__VITE_ASSET__BDblMMjW__"